import Marquee from "react-fast-marquee";
import { Zap } from "lucide-react";

const WORDS = ["NO CRASH", "NO JITTERS", "PURE FOCUS", "ZERO COMPROMISE"];

export const StrokeMarquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-zinc-800 bg-[#09090B] py-8"
    >
      <Marquee speed={60} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="stroke-text font-display text-6xl uppercase tracking-tight sm:text-8xl">
              {w}
            </span>
            <Zap className="mx-8 h-8 w-8 text-blaze sm:mx-12 sm:h-12 sm:w-12" fill="currentColor" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};
